import type { CARDS_ASPECT_RATIO, EVENT_CARD_ASPECT_RATIO } from 'blocks/Cards'
import type { CARDS_ASPECT_RATIO_VARS } from 'vars/cards-ascpect-ratio'
import type { GRID, ROW_GAP } from 'vars/index'
import type { CellsAlignment, ISnapAlign } from '../RowContainer.h'

import { styled } from '@linaria/react'
import { BaseCardSC } from 'blocks/Cards'
import { SimpleRowSkeletonItem } from 'blocks/Skeletons'
import { MEDIA } from 'vars/index'

export const SimpleCarouselScrollableComponentSC = styled.div<{
  gap: ROW_GAP | GRID
  withSpecialCell?: boolean
  visibleCards: number
  extraCount: number
  cellsAlignment?: CellsAlignment
  cardAspectRatio: (typeof CARDS_ASPECT_RATIO)[keyof typeof CARDS_ASPECT_RATIO]
  cardAspectRatioVar?: CARDS_ASPECT_RATIO_VARS | EVENT_CARD_ASPECT_RATIO
  withCardDescription?: boolean
  snapAlign: ISnapAlign
}>`
  overflow: scroll;
  padding: 0 var(--horizontalPaddings);

  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none; // firefox

  --cardsCount: ${({ extraCount }) => extraCount};
  --extraCount: calc(var(--cardsCount));
  --rowGap: ${({ gap }) => ` var(${gap})`};
  --visibleCards: ${({ visibleCards }) => visibleCards};
  --aspectRatio: ${({ cardAspectRatio, cardAspectRatioVar }) =>
    cardAspectRatioVar ? `var(${cardAspectRatioVar})` : cardAspectRatio};
  --specialCardWidth: ${({ gap }) =>
    `calc(var(--cardWidth) *  var(--extraCount) + var(${gap}) * ( var(--extraCount) - 1))`};
  display: flex;
  align-items: ${({ cellsAlignment, withCardDescription }) => {
    if (cellsAlignment) return cellsAlignment
    return withCardDescription ? 'flex-start' : 'stretch'
  }};
  gap: var(--rowGap);
  scroll-snap-type: x proximity;

  ${MEDIA.TOUCH} {
    scroll-snap-type: x mandatory;
  }

  > * {
    scroll-margin-left: var(--horizontalPaddings);
    flex: ${({ withCardDescription }) =>
      withCardDescription ? '0 0 var(--cardWidth)' : '0 0 auto'};
    /* Long episode synopsis copy must not widen the flex item and leave a gap
       before the next card (FP-4364). */
    min-width: ${({ withCardDescription }) =>
      withCardDescription ? '0' : 'initial'};
    max-width: ${({ withCardDescription }) =>
      withCardDescription ? 'var(--cardWidth)' : 'none'};
    width: var(--cardWidth);

    scroll-snap-align: ${({ snapAlign }) => snapAlign};

    height: ${({ withCardDescription }) =>
      withCardDescription
        ? 'auto'
        : `calc(var(--cardWidth) / var(--aspectRatio))`};

    &:first-child {
      width: ${({ withSpecialCell }) =>
        withSpecialCell ? 'var(--specialCardWidth)' : 'var(--cardWidth)'};
    }

    ${BaseCardSC} {
      height: calc(var(--cardWidth) / var(--aspectRatio));
      width: var(--cardWidth);
    }
  }

  ${SimpleRowSkeletonItem} {
    height: calc(var(--cardWidth) / var(--aspectRatio));
    width: var(--cardWidth);
  }
`
